import _ from 'underscore';
import { MenuItemSaleUnitHelper, TaxRoundingMode } from '@biteinc/enums';
/**
 * @description
 * `price` is the term used for price in cents. $12.34's `price` is 1234
 * `float5` is used to store decimals as ints. Store with a factor of 10^5
 * 8.875% in float5 is 8875. $10.8875 in float5 is 1088750
 */
export function divideValueBy10ToXAndCeil(value, lostPrecisionPoints) {
    return Math.ceil(value / Math.pow(10, lostPrecisionPoints));
}
function divideValueBy10ToXAndRound(value, lostPrecisionPoints) {
    return Math.round(value / Math.pow(10, lostPrecisionPoints));
}
function divideValueBy10ToXAndFloor(value, lostPrecisionPoints) {
    return Math.floor(value / Math.pow(10, lostPrecisionPoints));
}
export function float5FromPrice(price) {
    return price * 1000;
}
export function priceFromFloat5(float5Value) {
    return divideValueBy10ToXAndCeil(float5Value, 3);
}
export function float5RoundedToNearestCent(float5Value) {
    return float5FromPrice(priceFromFloat5(float5Value));
}
export function getFloat5Rate(numerator, denominator) {
    return Math.round((numerator / denominator) * 100000);
}
export function multiplyPriceByFloat5Rate(price, float5Rate) {
    const unrounded = price * float5Rate;
    return divideValueBy10ToXAndCeil(unrounded, 2);
}
export function getPercentageOfPrice(amount, float5Rate) {
    const float5Amount = multiplyPriceByFloat5Rate(amount, float5Rate);
    return priceFromFloat5(float5RoundedToNearestCent(float5Amount));
}
export function getTaxAmount(price, float5Rate, roundingMode) {
    const unrounded = price * float5Rate;
    switch (roundingMode) {
        case TaxRoundingMode.Ceil:
            return divideValueBy10ToXAndCeil(unrounded, 5);
        case TaxRoundingMode.Floor:
            return divideValueBy10ToXAndFloor(unrounded, 5);
        case TaxRoundingMode.Round:
            return divideValueBy10ToXAndRound(unrounded, 5);
    }
}
export function displayPrice(priceInCents, saleUnit) {
    let displayPriceStr = `${priceInCents || 0}`;
    if (_.isNumber(priceInCents)) {
        const dollars = priceInCents / 100;
        displayPriceStr = dollars.toFixed(2).toString();
    }
    if (saleUnit && MenuItemSaleUnitHelper.notation(saleUnit)) {
        displayPriceStr += `/${MenuItemSaleUnitHelper.notation(saleUnit)}`;
    }
    return displayPriceStr;
}
export function floatDollarsFromPrice(priceInCents) {
    const ret = priceInCents / 100.0;
    return parseFloat(ret.toFixed(2));
}
export function priceFromFloatDollars(floatDollars) {
    return Math.round(floatDollars * 100);
}
/**
 * Generates number between floor and ceiling
 * For 1000-9999 do floor = 1000 and max = 100000
 */
export function generateRandomCode(floor = 0, max = 100) {
    return Math.floor(floor + Math.random() * (max - floor));
}
//# sourceMappingURL=universal_math_helper.js.map